"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusEditCell = void 0;
const react_1 = __importStar(require("react"));
const graphql_1 = require("../../../../../__generated__/graphql");
const ui_components_1 = require("@groupby/ui-components");
const table_cells_1 = require("../../../../common/table-cells");
const valueToStatusVariantMap = {
    [graphql_1.PriorityTaskStatus.Escalated]: ui_components_1.DataGridStatusCellVariant.Danger,
    [graphql_1.PriorityTaskStatus.InProgress]: ui_components_1.DataGridStatusCellVariant.Info,
    [graphql_1.PriorityTaskStatus.NotStarted]: ui_components_1.DataGridStatusCellVariant.Neutral,
    [graphql_1.PriorityTaskStatus.Reviewed]: ui_components_1.DataGridStatusCellVariant.Success,
};
const StatusEditCell = ({ id, field, value, options, }) => {
    const valueToLabelMap = (0, react_1.useMemo)(() => (options.reduce((acc, option) => {
        acc[option.value] = option.label;
        return acc;
    }, {})), [options]);
    const renderStatusOption = (option) => (react_1.default.createElement(ui_components_1.DataGridCellStatus, { value: option.value, valueToLabelMap: valueToLabelMap, valueToStatusVariantMap: valueToStatusVariantMap }));
    return (react_1.default.createElement(table_cells_1.AutocompleteEditCell, { id: id, field: field, value: value, options: options, renderOption: renderStatusOption, renderValue: renderStatusOption }));
};
exports.StatusEditCell = StatusEditCell;
